import {openModal, popModal, setModalState} from "@/redux/modal/ModalSlice";
import { VISIBLE_TIME_OUT } from "@/components/constants";

/**
 * 모달 오픈 처리
 * - 모달 스택에 추가 후 일정 시간 뒤 visible 활성화
 * @param {Object} config - 모달 설정 객체
 * @returns {Function} Redux thunk 함수
 */
// MobX openModal 동일: push -> 50ms 후 visible true
export const openModalAsync = (config) => (dispatch) => {
    dispatch(openModal(config));

    setTimeout(() => {
        dispatch(setModalState(true));
    }, 50);
};

/**
 * 현재 열린 마지막 모달 닫기 처리
 * - visible false 처리 후 애니메이션 종료 시 제거
 * @returns {Function} Redux thunk 함수
 */
export const pop = () => (dispatch, getState) => {
    const list = getState().modal?.MODAL_INIT_OPENED || [];
    if (!list.length) return;

    dispatch(setModalState(false));
    setTimeout(() => {
        dispatch(popModal());
    }, VISIBLE_TIME_OUT);
};